var map = {
	"./discord.svg": 42038,
	"./facebook.svg": 34951,
	"./gamepedia.svg": 61493,
	"./instagram.svg": 3004,
	"./kickstarter.svg": 32022,
	"./twitch.svg": 25161,
	"./twitter.svg": 26715,
	"./vk.svg": 68326,
	"./wechat.svg": 55939,
	"./youtube.svg": 5298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99144;